import styled from 'styled-components';
import React, { useContext } from 'react';
import { RadioButtons } from '@/features/editor/widgets/custom-widget/inputs/shared/radio-buttons';
import { DropdownInputOption } from '@/features/editor/widgets/custom-widget/inputs/shared/dropdown';
import { PriceTestContext } from '@/features/editor/widgets/price-test/context';
import { PTQuizAnswer } from '@/features/editor/widgets/price-test/props';

const OPTIONS: DropdownInputOption[] = [
  { label: `No`, value: `NO` },
  { label: `Yes`, value: `YES` },
  { label: `Not sure`, value: `NOT_SURE` },
];

export function PriceTestStepQuiz() {
  const { props, setProps } = useContext(PriceTestContext);

  return (
    <Wrapper>
      <RadioButtons
        title="1. Is there any option to split payments on the product page?"
        allowCustomEdit={false}
        options={OPTIONS}
        defaultValue={props?.quiz?.hasSplitPayments}
        onChange={(val) =>
          setProps((draft) => {
            draft.quiz.hasSplitPayments = val as PTQuizAnswer;
          })
        }
      />

      <RadioButtons
        title="2. Is the price shown on buttons, for example, on the 'Add to Cart' button?"
        allowCustomEdit={false}
        options={OPTIONS}
        defaultValue={props?.quiz?.priceShownOnButtons}
        onChange={(val) =>
          setProps((draft) => {
            draft.quiz.priceShownOnButtons = val as PTQuizAnswer;
          })
        }
      />

      <RadioButtons
        title="3. Do you offer bundles? "
        allowCustomEdit={false}
        options={OPTIONS}
        defaultValue={props?.quiz?.bundles}
        onChange={(val) =>
          setProps((draft) => {
            draft.quiz.bundles = val as PTQuizAnswer;
          })
        }
      />

      <RadioButtons
        title="4. Is there anything special on your site that we need to look at before starting the pricing test?"
        allowCustomEdit
        customEditCaption="Yes, please specify"
        options={[{ label: `No`, value: `NO` }]}
        defaultValue={props?.quiz?.custom ?? `NO`}
        onChange={(val) =>
          setProps((draft) => {
            draft.quiz.custom = val as PTQuizAnswer;
          })
        }
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-top: 1rem;

  .radio-title {
    font-family: Inter, sans-serif;
    font-size: 1.2rem;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: -0.37px;
    color: #8f969e;
  }

  .radio-chip {
    font-family: Inter, sans-serif;
    font-size: 1.2rem;
    font-weight: 500 !important;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: -0.37px;
    color: #a6afb8;
    border-radius: 2rem;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0),
      0 0.5px 0.5px 0 rgba(0, 0, 0, 0.15);
    background-color: #eaf0f6;
    min-width: 9rem;
  }

  .radio-custom-edit-title {
    display: none;
  }

  .radio-chip.selected {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0),
      0 6.5px 8px 0 rgba(151, 210, 206, 0.22),
      0 0.5px 0.5px 0 rgba(0, 0, 0, 0.15);
    background-color: #fff;
    color: #8f969e;
  }

  .radio-textarea {
    min-height: 10rem;
  }
`;
